

import React from 'react';
import { useHistory } from 'react-router-dom';

const Footer = () => {
    const history = useHistory();

    const navigateTo = (path) => {
        history.push(path);
    };

    const facebookUrl = 'https://www.facebook.com/share/195R8ans7E/';
    const instagramUrl = 'https://www.instagram.com/trustyou_doctor?igsh=NHE3ZGhwdGY2Zzh2';

    const btnStyle = {
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        color: 'white',
        padding: 0,
        fontSize: '14px',
        textAlign: 'left'
    };

    const linkStyle = {
        color: 'white',
        textDecoration: 'none',
        fontSize: '14px'
    };

    const liStyle = { marginBottom: '10px' };

    const headingStyle = {
        textTransform: 'uppercase',
        fontWeight: '700',
        marginBottom: '14px',
        fontSize: '15px',
        letterSpacing: '1px'
    };

    return (
        <footer style={{ background: '#1a2d67', color: 'white' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 24px' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px' }}>

                    {/* Description */}
                    <div style={{ flex: '2', minWidth: '220px' }}>
                        <h5 style={headingStyle}>Trust You Doctor</h5>
                        <p style={{
                            fontFamily: 'sans-serif',
                            textAlign: 'justify',
                            fontWeight: '300',
                            color: 'rgba(255,255,255,0.85)',
                            lineHeight: '1.7',
                            fontSize: '14px',
                            margin: 0
                        }}>
                            Welcome to Trust You Doctor, connecting healthcare seamlessly. Book appointments with skilled
                            doctors and hospitals. We are dedicated to accessible and quality healthcare. Join us in
                            fostering a healthier community. Trusted by both healthcare providers and patients.
                        </p>
                    </div>

                    {/* About */}
                    <div style={{ flex: '1', minWidth: '120px' }}>
                        <h5 style={headingStyle}>About</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/About')} style={btnStyle}>
                                    About us
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Contact')} style={btnStyle}>
                                    Contact us
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Explore */}
                    <div style={{ flex: '1', minWidth: '120px' }}>
                        <h5 style={headingStyle}>Explore</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/')} style={btnStyle}>
                                    Home
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/SDoctor')} style={btnStyle}>
                                    Doctor
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Hospital')} style={btnStyle}>
                                    Hospital
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/treatment/india')} style={btnStyle}>
                                    Treatment in India
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/ayurveda-wellness')} style={btnStyle}>
                                    Ayurveda &amp; Wellness
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/doctors-thoughts')} style={btnStyle}>
                                    Doctors' Thoughts
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/articles')} style={btnStyle}>
                                    Articles
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/conferences')} style={btnStyle}>
                                    Upcoming Conferences
                                </button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/job-post')} style={btnStyle}>
                                    Job Post
                                </button>
                            </li>
                        </ul>
                    </div>

                    {/* Doctor Career */}
                    <div style={{ flex: '1', minWidth: '150px' }}>
                        <h5 style={headingStyle}>Doctor Career</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Doctor/Australia')} style={btnStyle}>Australia</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Doctor/USA')} style={btnStyle}>USA</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Doctor/Germany')} style={btnStyle}>Germany</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/under-renovation')} style={btnStyle}>Other Countries</button>
                            </li>
                        </ul>
                    </div>

                    {/* Dentist Career */}
                    <div style={{ flex: '1', minWidth: '150px' }}>
                        <h5 style={headingStyle}>Dentist Career</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Dentist/Australia')} style={btnStyle}>Australia</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Dentist/USA')} style={btnStyle}>USA</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Dentist/Germany')} style={btnStyle}>Germany</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/under-renovation')} style={btnStyle}>Other Countries</button>
                            </li>
                        </ul>
                    </div>

                    {/* Physiotherapy */}
                    <div style={{ flex: '1', minWidth: '150px' }}>
                        <h5 style={headingStyle}>Physiotherapy</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/physio/Australia')} style={btnStyle}>Australia</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/physio/USA')} style={btnStyle}>USA</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/physio/Germany')} style={btnStyle}>Germany</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/under-renovation')} style={btnStyle}>Other Countries</button>
                            </li>
                        </ul>
                    </div>

                    {/* Nurse Career */}
                    <div style={{ flex: '1', minWidth: '150px' }}>
                        <h5 style={headingStyle}>Nurse Career</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Nurse/Australia')} style={btnStyle}>Australia</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Nurse/USA')} style={btnStyle}>USA</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Nurse/Germany')} style={btnStyle}>Germany</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/under-renovation')} style={btnStyle}>Other Countries</button>
                            </li>
                        </ul>
                    </div>

                    {/* Paramedical Career */}
                    <div style={{ flex: '1', minWidth: '150px' }}>
                        <h5 style={headingStyle}>Paramedical Career</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Para/Australia')} style={btnStyle}>Australia</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Para/USA')} style={btnStyle}>USA</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/Para/Germany')} style={btnStyle}>Germany</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/under-renovation')} style={btnStyle}>Other Countries</button>
                            </li>
                        </ul>
                    </div>

                    {/* Language Learning */}
                    <div style={{ flex: '1', minWidth: '150px' }}>
                        <h5 style={headingStyle}>Language Learning</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/learning/germanlang')} style={btnStyle}>German Language</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/learning/toefllang')} style={btnStyle}>TOEFL · IELTS · OET</button>
                            </li>
                        </ul>
                    </div>

                    {/* Account */}
                    <div style={{ flex: '1', minWidth: '120px' }}>
                        <h5 style={headingStyle}>Account</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/login')} style={btnStyle}>Login</button>
                            </li>
                            <li style={liStyle}>
                                <button onClick={() => navigateTo('/register')} style={btnStyle}>Register</button>
                            </li>
                        </ul>
                    </div>

                    {/* Social */}
                    <div style={{ flex: '1', minWidth: '120px' }}>
                        <h5 style={headingStyle}>Social</h5>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={liStyle}>
                                <a href={facebookUrl} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                                    Facebook
                                </a>
                            </li>
                            <li style={liStyle}>
                                <a href={instagramUrl} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                                    Instagram
                                </a>
                            </li>
                            <li style={liStyle}>
                                <button style={btnStyle}>
                                    Twitter
                                </button>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>

            {/* Copyright */}
            <div style={{ backgroundColor: 'rgba(0,0,0,0.2)', textAlign: 'center', padding: '14px' }}>
                <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)' }}>
                    {String.fromCharCode(169)} {new Date().getFullYear()} Copyright{' '}
                </span>
                <button onClick={() => navigateTo('/')} style={{ ...btnStyle, fontSize: '13px', color: 'white', fontWeight: '600' }}>
                    Trustyoudoctor.com
                </button>
            </div>
        </footer>
    );
};

export default Footer;